import * as angular from "angular";
import {IController} from "angular";
import {UserModel} from "../../models/user.model";
import * as _ from "lodash";
import {CommonsService} from "../../../commons/services/commons-service.service";

export class adminUserFormCtrl implements IController {

  form: any;
  user: UserModel;
  passwordPolicy: any;
  onPasswordChange: Function;

  public zxExtras: string[] = [];

  /* @ngInject */
  constructor(private commonsService: CommonsService) {
  }

  $onInit() {

  }

  $onChanges(changes) {
    if (changes.user && !changes.user.isFirstChange()) {
      this._zxExtras();
    }
  }

  onEmailChange() {
    this._zxExtras();
  }

  private _zxExtras() {
    this.zxExtras = this.user.email ?
      this.commonsService.buildZxExtras(this.user.email) :
      [];
  }

}

angular
  .module('bringoz.admin.policies')
  .component('adminUserForm', {
    require: {
      form: '^form'
    },
    bindings: {
      user: '<',
      passwordPolicy: '<?',
      onPasswordChange: '&'
    },
    template: require('./admin-user-form.html').default,
    controller: adminUserFormCtrl
  });
